import { initTabs } from '../common'
import { HashHandler } from '../hash_handler';


const loadGoogleMapsApi = require('load-google-maps-api')

/**
 * Host editor
 */
class Host {
    constructor(hostId, userId, settings) {
        this.hostId = 0;
        this.userId = 0;
        this.admin = false;
        this.verified = false;
        this.lat = 0;
        this.lng = 0;
        this.texts = {};

        this.descriptionExpanded = false;

        this.map = null;
        this.mapCoordinates = null;
        this.mapExpanded = false;

        var that = this;

        this.hostId = hostId;
        this.userId = userId;
        if (settings){
            this.admin = settings.admin;
            this.verified = settings.verified;
            this.lat = settings.lat;
            this.lng = settings.lng;
            this.texts = settings.texts;
        }

        // hash handler
        this.hashHandler = new HashHandler();
        this.hashHandler.addAction('#follow', false, function() {
            if(!window.evedo.isLogged()) {
                window.evedo.openLogin();
            }
            else {
                that.followHost();
                that.hashHandler.clearHash();
            }
        });

        // init layout
        this.initLayout();

       if(!$('section.create-host')[0]) return;

        $("#image-drop-area a.delete-image").on("click", function(e){
            e.preventDefault();
            if (window.confirm(window.createHostTranslations.areYouSureDelImg)) {
                $('input[name="existing-image"]').val(0);
                $('input[name="uploaded-image"]').val(0);
                $("#upimg").attr('src', '').attr('style', '');
                $("#imageupload").replaceWith($("#imageupload").clone( true ));
                $("#imageupload").val('');
                $("#image-drop-area a.delete-image").remove();

                appendDelImg = true;
            };
        });
    }

    initLayout() {
        var that = this;

        if(this.admin) {
            this.initEditables();

            $('#imageupload').change(function(e) {
                $('#imageform').submit();
            });

            $('#cancel-host').click(function() {
                that.cancelHost();
                return false;
            });
        }

        this.initFollowButton();
        this.initRating();
        this.initDescription();
        this.initMap();
        this.initUpcomingEvents();
        // this.initComments();
        this.initImagePreviews();
        this.initPastEvents();

        initTabs();
    }

// EDITABLES, CANCEL HOST -------------------------------------------------------------

    initEditables() {
        var that = this;

        // name
        $('.editable-name').editable('/promoter/save-single/?host=' + that.hostId, {
            cssclass: 'jeditable name',
            type: 'text',
            loadtext: that.texts.saving,
            placeholder: that.texts.clickToEdit,
            onblur: 'submit',

            onsubmit : function (settings, original) {
                if(that.verified) {
                    $('#verified-host').show();
                    $('hgroup').addClass('verified-host');
                }

                if(original.revert == $('input',this).val() || $.trim($('input',this).val()).length == 0) {
                    original.reset();
                    return false;
                }
            },

            onedit : function (settings, original) {
                if(that.verified) {
                    $('#verified-host').hide();
                    $('hgroup').removeClass('verified-host');
                }
            }
        });

        // short-description
        $('.editable-short-description').editable('/promoter/save-single/?host=' + that.hostId, {
            cssclass: 'jeditable short-description',
            type: 'text',
            loadtext: that.texts.saving,
            placeholder: that.texts.clickToEdit,
            onblur: 'submit',

            onsubmit: function (settings, original) {
                if(original.revert == $('input',this).val()) {
                    original.reset();
                    return false;
                }
            }
        });

        // description
        $('.editable-description').editable('/promoter/save-single/?host=' + that.hostId, {
            cssclass: 'jeditable description',
            type: 'textarea',
            loadtext: that.texts.saving,
            placeholder: that.texts.clickToEdit,
            onblur: 'submit',

            data: function(original, settings) {
                original = $('<div>' + original + '</div>');

                $('a', original).each(function (key, el) {
                    $(el).text($(el).attr('href'));
                });

                return original.text();
            },

            onedit: function (settings, original) {
                $('#url-image-preview').remove();
                that.initDescription(true);
            },

            onsubmit: function (settings, original) {
                if(original.revert == $('textarea', this).val() || $.trim($('textarea', this).val()).length == 0) {
                    original.reset();
                    return false;
                }
            },

            callback: function(value, settings) {
                that.initDescription();
                that.expandDescription(true);
            }
        });
    }

    cancelHost() {
        var that = this;

        if (window.confirm(that.texts.deleteHost)){
            $.ajax({
                url: '/promoter/cancel/',
                dataType: 'json',
                method: 'post',
                data: {
                    id: that.hostId
                },
                success: function(data) {
                    if(data && data.success != undefined && data.success) {
                        window.location = '/';
                    }
                }
            });
        };
    }

// FOLLOW BUTTON ----------------------------------------------------------------------

    initFollowButton() {
        var that = this;

        // if($('section.summary').hasClass('vertical')) {
        //     // var imageWidth = $('section.summary').find('img').width();

        //     // $('section.summary').find('div.information').width(730 - imageWidth);
        //     // $('section.summary').find('div.social').css('marginLeft', Math.floor((730 - imageWidth - 40 - 245) * 0.5) + 2);
        // }

        $('#follow-button').click(function() {
            that.toggleFollow();
            return false;
        });
    }

    toggleFollow() {
        if(!window.evedo.isLogged()) {
            window.evedo.openLogin();
            return false;
        }

        (!$('#follow-button').hasClass('following')) ? this.followHost() : this.unfollowHost();
        return false;
    }

    followHost() {
        profile.follow(this.hostId, function() {
            $('#follow-button').addClass('following').mouseover();
        });
    }

    unfollowHost() {
        profile.unfollow(this.hostId, function() {
            $('#follow-button').removeClass('following');
        });
     }

// RATING -----------------------------------------------------------------------------

    initRating() {
        if(!window.evedo.isLogged()) return;
        var that = this;

        $('div.rating a', 'section.summary').each(function() {
            $(this)
                .mouseover(function() {
                    $(this).parent().addClass('no-background');
                })
                .mouseout(function() {
                    $(this).parent().removeClass('no-background');
                })
                .click(function() {
                    that.rateHost($(this).data('rating'));
                    return false;
                });
        });
    }

    rateHost(stars) {
        var rating = $('div.rating', 'section.summary');

        if(rating.attr('rel') == 'tooltip') {
            rating
                .tooltip('hide')
                .attr('data-original-title', this.texts.thanksForVoting)
                .tooltip('fixTitle')
                .tooltip('show');
        }
        else {
            rating
                .attr('rel', 'tooltip')
                .attr('title', this.texts.thanksForVoting)
                .tooltip({ animation: false });
            rating.tooltip('show');
        }

        rating
            .attr('data-original-title', this.texts.voted.replace(/%d/, stars))
            .tooltip('fixTitle');

        $.ajax({
            url: "/promoter/rate/",
            dataType: 'json',
            method: 'post',
            data: {
                id: this.hostId,
                rating: stars
            },
            success: function(data) {
                if(data) {
                    $('div', rating).css('width', data['rating'] + '%');
                }
            }
        });
    }

// DESCRIPTION -----------------------------------------------------------------------

    initDescription(reset) {
        var that = this;
        this.descriptionExpanded = true;

        $('#host_description').removeClass('transition').css('height', 'auto');
        $('#full-description').removeClass('collapse').css('display', 'none').unbind('click');

        if(reset) return;

        if($('#host_description').outerHeight() >= 180) {
            this.descriptionExpanded = false;

            $('#host_description').css('height', '100px');
            $('#full-description').css('display', 'block').bind('click', function() {
                (!that.descriptionExpanded) ? that.expandDescription() : that.collapseDescription();
                return false;
            });
        }
    }

    expandDescription(noTransition) {
        var descriptionHeight = 0;
        var that = this;

        this.descriptionExpanded = true;

        $('p', '#host_description').each(function() {
            descriptionHeight += $(this).outerHeight();
        });

        $('#full-description').addClass('collapse');
        (noTransition) ? $('#host_description').removeClass('transition') : $('#host_description').addClass('transition');
        $('#host_description').css('height', descriptionHeight);
    }

    collapseDescription(a) {
        this.descriptionExpanded = false;

        $('#full-description').removeClass('collapse');
        $('#host_description').addClass('transition').css('height', '100px');
    }

// MAP -------------------------------------------------------------------------------

    initMap() {
        var that = this;

        if(!this.lat && !this.lng) return;

        
        loadGoogleMapsApi({'key': window.googleApiPublicKey, libraries: ['places']}).then(function (googleMaps) {
            that.mapCoordinates = new googleMaps.LatLng(that.lat, that.lng);
            that.mapStyles = [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }];

            that.map = new googleMaps.Map(document.getElementById('host-map-canvas'), {
                center: that.mapCoordinates,
                draggable: false,
                mapTypeControl: false,
                mapTypeId: googleMaps.MapTypeId.ROADMAP,
                minZoom: 15,
                maxZoom: 15,
                panControl: false,
                scaleControl: false,
                scrollwheel: true,
                streetViewControl: false,
                styles: that.mapStyles,
                zoom: 15,
                zoomControl: false
            });
            that.map.panBy(0, -15);

            var marker = new googleMaps.Marker({
                map: that.map,
                draggable: false,
                position: that.mapCoordinates
            });
        }).catch(function (error) {
          console.error(error)
        });

        $('.jump-to-map').click(function() {
            var wasExpanded = that.mapExpanded;

            that.expandMap();
            $('html, body').animate({
                scrollTop: $('section.summary').offset().top + $('section.summary').outerHeight() - $(window).height() + (wasExpanded ? 20 : 220)
            }, { duration: 200, queue: false });

            return false;
        });

        $('#expand-map').click(function() {
            that.expandMap();
            return false;
        });

        $('#collapse-map').click(function() {
            that.collapseMap();
            return false;
        });
    }

    expandMap() {
        if(this.mapExpanded) return;

        var that = this;
        this.mapExpanded = true;

        $('#map-text').css('display', 'block');
        $('#host-map-canvas').height(300);
        $('#expand-map').css('display', 'none');

        this.map.setOptions({
            draggable: true,
            minZoom: 10,
            maxZoom: 18,
            zoomControl: true
        });

        setTimeout(function() {
            google.maps.event.trigger(that.map, 'resize');
            that.map.setCenter(that.mapCoordinates);
        }, 210);
    }

    collapseMap() {
        if(!this.mapExpanded) return;

        var that = this;
        this.mapExpanded = false;

        $('#map-text').css('display', 'none');
        $('#host-map-canvas').height(100);
        $('#expand-map').css('display', 'block');

        this.map.setOptions({
            draggable: false,
            minZoom: 15,
            maxZoom: 15,
            zoom: 15,
            zoomControl: false
        });

        setTimeout(function() {
            google.maps.event.trigger(that.map, 'resize');
            that.map.setCenter(that.mapCoordinates);
            that.map.panBy(0, -15);
        }, 210);
    }

// FUTURE EVENTS ----------------------------------------------------------------------

    initUpcomingEvents() {
        var that = this;
        var hostEvents = $('section.host-events');
        var pageUpcoming = 2;

        $('a[class^="marker-"]', hostEvents).on('click', function() {
            var button = $(this);

            profile.rsvp(button.parent('div.info').data('event'), button.data('status'), true, function() {
                $.each(button.siblings(), function() {
                    if($(this).data('status') != undefined) {
                        $(this).addClass('disabled');
                    }
                });

                button.removeClass('disabled');
            });

            return false;
        });

        $('a.more', hostEvents).click(function() {
            $.ajax({
                url: '/promoter/upcoming-events/',
                dataType: 'json',
                method: 'post',
                data: {
                    id: that.hostId,
                    userId: that.userId,
                    page: pageUpcoming
                },
                success: function(data) {
                    if(data != undefined && data.view != undefined && data.view.length != 0){
                        $(data.view).appendTo($('div.events-list-horizontal-row'));
                        if(!data.more) $('a.more', hostEvents).remove();
                    }
                    else{
                        $('a.more', hostEvents).remove();
                    }

                    pageUpcoming++;
                }
            });

            return false;
        });
    }

// COMMENTS ---------------------------------------------------------------------------

    initComments() {
        var that = this;

        $("#discussions-box textarea").on('keyup', function(e) {
            if (e.keyCode === 13 && !e.shiftKey) {
                that.sendComment();
            }
            return true;
        });

        $('button', '#discussions-box').click(function() {
            that.sendComment();
            return false;
        });

        $('div.paging a', '#discussions-box').on('click', function() {
            that.readComments($(this).data('page'));
            return false;
        });

        window.setInterval(function(){
            that.refreshComments();
        }, 30000);
    }

    readComments(page) {
        if(!window.evedo.isLogged() && page > 1) {
            window.evedo.openLogin();
            return;
        }

        $.ajax({
            url: '/read-comment/',
            dataType: 'json',
            method: 'post',
            data: {
                target: 'host',
                id: this.hostId,
                page: page
            },
            success: function(data) {
                if(data) {
                    if(data.commentsCount) {
                        if(!$('span', '#discussions-tab').length) $('#discussions-tab').append('<span></span>');
                        $('span', '#discussions-tab').text(data.commentsCount);
                        $('#discussions-box div.no-items, #discussions-box .item, #discussions-box .paging').remove();
                        $('#discussions-box').prepend(data.comments);
                    }
                }
            }
        });
    }

    sendComment() {
        if(!window.evedo.isLogged()) {
            window.evedo.openLogin();
            return;
        }

        var that = this;
        var message = $.trim($('textarea[name="message"]', '#discussions-box').val());

        if(message.length == 0) return;

        $.ajax({
            url: '/send-comment/',
            dataType: 'json',
            method: 'post',
            data: {
                target: 'host',
                id: that.hostId,
                message: message
            },
            success: function(data) {
                if(data) {
                    if(data.commentsCount > 0) {
                        if(!$('span', '#discussions-tab').length) $('#discussions-tab').append('<span></span>');
                        $('span', '#discussions-tab').text(data.commentsCount);
                    }

                    $('#discussions-box .item, #discussions-box .paging').remove();
                    $('#discussions-box').prepend(data.comments);
                    $('#discussions-box textarea[name="message"]').val('');
                    $('#discussions-box .no-items').remove();
                    $.ajax({
                        url: '/send-comment-facebook/',
                        dataType: 'json',
                        method: 'post',
                        data: {
                            target: 'host',
                            id: that.hostId
                        },
                        success: function(data) {
                        }
                    });
                }
            }
        });
    }

    refreshComments() {
        this.readComments($('div.paging a.active', '#discussions-box').data('page'));
    }

// IMAGE PREVIEWS ---------------------------------------------------------------------

    initImagePreviews() {
        $('#host_description a[href], #discussions-box a[href]').on({
            mouseover: function(e) {
                if(!/(jpg|gif|png)$/.test($(this).attr('href'))) {
                    return false;
                }
                else {
                    var containerOffset = Math.ceil(($(document).width() - 980) * 0.5);
                    var imageBox = null;
                    var offsetLeft = 0;
                    var that = $(this);

                    $('body').append(
                        '<div id="url-image-preview">' +
                            '<img alt="" id="url-image-preview-image" src="'+ $(this).attr('href') +'" />' +
                        '</div>'
                    );

                    imageBox = $('#url-image-preview');

                    $('#url-image-preview-image').load(function() {
                        imageBox.css({
                            marginTop: imageBox.height() * -0.5,
                            opacity: 1.0,
                            top: that.offset().top + 3
                        });

                        offsetLeft = that.offset().left + that.width() + 15;

                        if(offsetLeft + imageBox.width() + 10 >= containerOffset + 760 && that.width() <= 250) {
                            imageBox.addClass('position-left').css({
                                right: $(document).width() - that.offset().left + 15
                            });
                        }
                        else {
                            imageBox.addClass('position-right').css({
                                left: offsetLeft
                            });
                        }
                    });
                }
            },
            mouseout: function () {
                $('#url-image-preview').remove();
            },
            click: function () {
                $('#url-image-preview').remove();
            }
        });
    }

// PAST EVENTS ------------------------------------------------------------------------

    initPastEvents() {
        var that = this;

        $('div.paging a', 'section.past-events-widget').on('click', function() {
            $.ajax({
                url: '/promoter/past-events/',
                dataType: 'json',
                type: 'post',
                data: {
                    id: that.hostId,
                    page: $(this).data('page')
                },
                success: function(data) {
                    if(data) $('section.past-events-widget').html(data);
                }
            });

            return false;
        });
    }

    notableChange() {
        var that = this;

        $.ajax({
            url: '/promoter/notable/change',
            dataType: 'json',
            method: 'post',
            data: {
                id: that.hostId,
                notable: $('#notable-chbx').is(":checked")
            }
        }).done(function(data){
            window.location.reload();
        });
    }
};

export { Host }
